export const LESS_OR_EQUAL_SIGN = '\u2264';
export const GREATER_OR_EQUAL_SIGN = '\u2265';

export const ANTIBODY_CHAIN_GREEK_NAMES = {
  K: '\u03BA',
  L: '\u03BB',
  A: '\u03B1',
  B: '\u03B2',
  G: '\u03B3',
  D: '\u03B4',
};

export const EN_DASH = '\u2013';

export const DEGREE_SIGN = '\u00B0';

export const NON_BREAKING_SPACE = '\u00A0';

export const MELTING_TEMP_ABBREVIATION = 'T\u2098'; // for melting temp Tm with subscript m
